module.exports = __webpack_public_path__ + "img/bs-logo-company.2215bc04.png";